import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Reveal } from "@/components/launchx/Reveal";

export const AgencyFAQ = ({ content }) => {
  const faqs = content?.faqs || [];
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="agency-faq" className="bg-background py-20 sm:py-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-blue-600 text-center">FAQ</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 text-center">
            Straight answers, no jargon
          </h2>
        </Reveal>
        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div data-testid={`agency-faq-item-${i}`} className="bg-white border border-slate-200/80 rounded-2xl overflow-hidden">
                <button data-testid={`agency-faq-question-${i}`} onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left">
                  <span className="text-sm font-semibold text-slate-900">{f.q}</span>
                  <ChevronDown size={17} className={`shrink-0 text-electric transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25 }}>
                      <p className="px-6 pb-5 text-sm text-slate-600 leading-relaxed" data-testid={`agency-faq-answer-${i}`}>{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
